'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var extend = require('xtend');

var DuplexStream = require('stream').Duplex;

var ObservableStore =
/*#__PURE__*/
function (_DuplexStream) {
  _inherits(ObservableStore, _DuplexStream);

  function ObservableStore() {
    var _this;

    var initState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ObservableStore);

    // construct as duplex stream
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ObservableStore).call(this, {
      // pass values not serializations
      objectMode: true,
      // a writer can end and we are still readable
      allowHalfOpen: true
    })); // dont buffer outgoing updates

    _this.resume(); // set init state


    _this._state = initState;
    return _this;
  } // wrapper around internal getState


  _createClass(ObservableStore, [{
    key: "getState",
    value: function getState() {
      return this._getState();
    } // wrapper around internal putState

  }, {
    key: "putState",
    value: function putState(newState) {
      this._putState(newState);

      this.emit('update', newState);
      this.push(this.getState());
    }
  }, {
    key: "updateState",
    value: function updateState(partialState) {
      // if non-null object, merge
      if (partialState && typeof partialState === 'object') {
        var state = this.getState();
        var newState = Object.assign({}, state, partialState);
        this.putState(newState); // if not object, use new value
      } else {
        this.putState(partialState);
      }
    } // subscribe to changes

  }, {
    key: "subscribe",
    value: function subscribe(handler) {
      this.on('update', handler);
    } // unsubscribe to changes

  }, {
    key: "unsubscribe",
    value: function unsubscribe(handler) {
      this.removeListener('update', handler);
    } //
    // private
    //
    // read from persistence

  }, {
    key: "_getState",
    value: function _getState() {
      return this._state;
    } // write to persistence

  }, {
    key: "_putState",
    value: function _putState(newState) {
      this._state = newState;
    } //
    // stream implementation
    //
    // emit current state on new destination

  }, {
    key: "pipe",
    value: function pipe(dest, options) {
      var result = DuplexStream.prototype.pipe.call(this, dest, options);
      dest.write(this.getState());
      return result;
    } // write from incomming stream to state

  }, {
    key: "_write",
    value: function _write(chunk, encoding, callback) {
      this.putState(chunk);
      callback();
    } // noop - outgoing stream is asking us if we have data we arent giving it

  }, {
    key: "_read",
    value: function _read(size) {}
  }]);

  return ObservableStore;
}(DuplexStream);

module.exports = ObservableStore;